// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 매도 등록 화면 */

/* ── 알림 아이콘 ── */
.sell-alert-icon {
  font-size: 10px;
  margin-left: 4px;
  cursor: pointer;
  vertical-align: middle;
}
.sell-alert-none  { opacity: 0.35; }
.sell-alert-gte   { color: #2e7d32; }
.sell-alert-lte   { color: #c62828; }
.sell-alert-both  { color: #e65100; }

/* 필터 툴바 */
.sell-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

/* 계좌 멀티셀렉트 드롭다운 */
.sell-acct-dropdown {
  position: relative;
}

.sell-acct-btn {
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
  background: white;
  cursor: pointer;
  white-space: nowrap;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sell-acct-btn:hover {
  border-color: #4a90e2;
}

.sell-acct-menu {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  min-width: 160px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.12);
  z-index: 200;
  padding: 4px 0;
  max-height: 220px;
  overflow-y: auto;
}

.sell-acct-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  font-size: 12px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.sell-acct-item:hover {
  background: #f0f4ff;
}

.sell-acct-item input[type="checkbox"] {
  width: 13px;
  height: 13px;
  cursor: pointer;
  flex-shrink: 0;
}

/* 체크박스 레이블 */
.sell-chk-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #444;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}

.sell-chk-label input[type="checkbox"] {
  width: 14px;
  height: 14px;
  cursor: pointer;
  flex-shrink: 0;
}

/* 매도기간 연도 선택 */
.sell-year-select {
  padding: 5px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
  background: white;
}

/* 합계 표시 텍스트 */
.sell-summary-text {
  font-size: 12px;
  color: #444;
  white-space: nowrap;
  margin-left: 4px;
}

.sell-summary-text strong {
  font-weight: 700;
}

/* 좌우 분할 레이아웃 */
.sell-body {
  display: flex;
  gap: 16px;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

/* 좌측 그리드 패널 */
.sell-list-panel {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sell-grid td {
  font-size: 12px;
}

/* 실시간 시세 로딩 스피너 */
.price-loading-spinner {
  display: inline-block;
  width: 9px;
  height: 9px;
  border: 2px solid #ccc;
  border-top-color: #4a90e2;
  border-radius: 50%;
  animation: price-spin 0.7s linear infinite;
  margin-left: 4px;
  vertical-align: middle;
}

@keyframes price-spin {
  to { transform: rotate(360deg); }
}

/* 컬럼 리사이즈 핸들 */
.col-resize-handle {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  cursor: col-resize;
  z-index: 1;
}

.col-resize-handle:hover {
  background: rgba(74, 144, 226, 0.35);
}

/* 매도완료 행 */
.row-sold {
  color: #bbb;
  background-color: #fafafa;
}

/* 다른 화면(건별수익률현황 매도금액 클릭 등)에서 넘어온 매도건 포커스 강조 */
.row-focus-highlight {
  animation: row-focus-flash 2.5s ease-out;
}
@keyframes row-focus-flash {
  0%   { background-color: #fff3cd; }
  100% { background-color: transparent; }
}

/* 보유/매도 뱃지 */
.badge-hold {
  background: #e8f5e9;
  color: #2e7d32;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
}

.badge-sold {
  background: #f0f0f0;
  color: #999;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 11px;
}

/* ── 우측 폼 패널 ── */
.sell-form-panel {
  width: 300px;
  flex-shrink: 0;
  background: white;
  border: 1px solid #e0e4ef;
  border-radius: 6px;
  padding: 14px 16px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.sell-form-title {
  font-size: 12px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

/* 섹션 구분 라벨 */
.sf-section-label {
  font-size: 11px;
  font-weight: 700;
  color: #4a90e2;
  margin: 6px 0 6px;
  padding-left: 2px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

/* 라벨 + 입력 가로 레이아웃 */
.sf-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 7px;
}

.sf-row > label {
  width: 74px;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: #444;
  text-align: right;
}

.sf-row input[type="text"],
.sf-row input[type="number"],
.sf-row input[type="date"],
.sf-row select,
.sf-row textarea {
  flex: 1 1;
  min-width: 0;
  padding: 5px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
  background: white;
  transition: border-color 0.2s;
}

.sf-row input:focus,
.sf-row select:focus,
.sf-row textarea:focus {
  outline: none;
  border-color: #4a90e2;
}

/* 폼 라벨 옆 도움말 아이콘 */
.sf-help {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 13px;
  height: 13px;
  margin-left: 4px;
  border-radius: 50%;
  background: #aaa;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  cursor: help;
  vertical-align: middle;
}

.sf-help:hover { background: #777; }

/* 읽기전용 */
.input-readonly {
  background: #f8f8f8 !important;
  color: #666;
  cursor: default;
}

/* 메모 textarea */
.sf-row-memo {
  align-items: flex-start;
}

.sf-row-memo > label {
  margin-top: 6px;
}

/* 저장/삭제/취소 버튼 */
.sf-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  padding-left: 82px;
}

.required { color: #e74c3c; }
`, "",{"version":3,"sources":["webpack://./src/pages/trade/SellPage.css"],"names":[],"mappings":"AAAA,aAAa;;AAEb,iBAAiB;AACjB;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;AACA,oBAAoB,aAAa,EAAE;AACnC,oBAAoB,cAAc,EAAE;AACpC,oBAAoB,cAAc,EAAE;AACpC,oBAAoB,cAAc,EAAE;;AAEpC,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA,WAAW;AACX;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE,wCAAwC;AAC1C;AACA;EACE,OAAO,yBAAyB,EAAE;EAClC,OAAO,6BAA6B,EAAE;AACxC;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,aAAa;AACb;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;;;;EAKE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,iBAAiB,gBAAgB,EAAE;;AAEnC,SAAS;AACT;EACE,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,YAAY,cAAc,EAAE","sourcesContent":["/* 매도 등록 화면 */\n\n/* ── 알림 아이콘 ── */\n.sell-alert-icon {\n  font-size: 10px;\n  margin-left: 4px;\n  cursor: pointer;\n  vertical-align: middle;\n}\n.sell-alert-none  { opacity: 0.35; }\n.sell-alert-gte   { color: #2e7d32; }\n.sell-alert-lte   { color: #c62828; }\n.sell-alert-both  { color: #e65100; }\n\n/* 필터 툴바 */\n.sell-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n/* 계좌 멀티셀렉트 드롭다운 */\n.sell-acct-dropdown {\n  position: relative;\n}\n\n.sell-acct-btn {\n  padding: 5px 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n  background: white;\n  cursor: pointer;\n  white-space: nowrap;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sell-acct-btn:hover {\n  border-color: #4a90e2;\n}\n\n.sell-acct-menu {\n  position: absolute;\n  top: calc(100% + 2px);\n  left: 0;\n  min-width: 160px;\n  background: white;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.12);\n  z-index: 200;\n  padding: 4px 0;\n  max-height: 220px;\n  overflow-y: auto;\n}\n\n.sell-acct-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 12px;\n  font-size: 12px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.sell-acct-item:hover {\n  background: #f0f4ff;\n}\n\n.sell-acct-item input[type=\"checkbox\"] {\n  width: 13px;\n  height: 13px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n/* 체크박스 레이블 */\n.sell-chk-label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: #444;\n  cursor: pointer;\n  user-select: none;\n  white-space: nowrap;\n}\n\n.sell-chk-label input[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n/* 매도기간 연도 선택 */\n.sell-year-select {\n  padding: 5px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n  background: white;\n}\n\n/* 합계 표시 텍스트 */\n.sell-summary-text {\n  font-size: 12px;\n  color: #444;\n  white-space: nowrap;\n  margin-left: 4px;\n}\n\n.sell-summary-text strong {\n  font-weight: 700;\n}\n\n/* 좌우 분할 레이아웃 */\n.sell-body {\n  display: flex;\n  gap: 16px;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* 좌측 그리드 패널 */\n.sell-list-panel {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.sell-grid td {\n  font-size: 12px;\n}\n\n/* 실시간 시세 로딩 스피너 */\n.price-loading-spinner {\n  display: inline-block;\n  width: 9px;\n  height: 9px;\n  border: 2px solid #ccc;\n  border-top-color: #4a90e2;\n  border-radius: 50%;\n  animation: price-spin 0.7s linear infinite;\n  margin-left: 4px;\n  vertical-align: middle;\n}\n\n@keyframes price-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* 컬럼 리사이즈 핸들 */\n.col-resize-handle {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 5px;\n  cursor: col-resize;\n  z-index: 1;\n}\n\n.col-resize-handle:hover {\n  background: rgba(74, 144, 226, 0.35);\n}\n\n/* 매도완료 행 */\n.row-sold {\n  color: #bbb;\n  background-color: #fafafa;\n}\n\n/* 다른 화면(건별수익률현황 매도금액 클릭 등)에서 넘어온 매도건 포커스 강조 */\n.row-focus-highlight {\n  animation: row-focus-flash 2.5s ease-out;\n}\n@keyframes row-focus-flash {\n  0%   { background-color: #fff3cd; }\n  100% { background-color: transparent; }\n}\n\n/* 보유/매도 뱃지 */\n.badge-hold {\n  background: #e8f5e9;\n  color: #2e7d32;\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.badge-sold {\n  background: #f0f0f0;\n  color: #999;\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-size: 11px;\n}\n\n/* ── 우측 폼 패널 ── */\n.sell-form-panel {\n  width: 300px;\n  flex-shrink: 0;\n  background: white;\n  border: 1px solid #e0e4ef;\n  border-radius: 6px;\n  padding: 14px 16px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.08);\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.sell-form-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: #1a1a2e;\n  margin: 0 0 10px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #eee;\n}\n\n/* 섹션 구분 라벨 */\n.sf-section-label {\n  font-size: 11px;\n  font-weight: 700;\n  color: #4a90e2;\n  margin: 6px 0 6px;\n  padding-left: 2px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n/* 라벨 + 입력 가로 레이아웃 */\n.sf-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 7px;\n}\n\n.sf-row > label {\n  width: 74px;\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #444;\n  text-align: right;\n}\n\n.sf-row input[type=\"text\"],\n.sf-row input[type=\"number\"],\n.sf-row input[type=\"date\"],\n.sf-row select,\n.sf-row textarea {\n  flex: 1;\n  min-width: 0;\n  padding: 5px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n  background: white;\n  transition: border-color 0.2s;\n}\n\n.sf-row input:focus,\n.sf-row select:focus,\n.sf-row textarea:focus {\n  outline: none;\n  border-color: #4a90e2;\n}\n\n/* 폼 라벨 옆 도움말 아이콘 */\n.sf-help {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 13px;\n  height: 13px;\n  margin-left: 4px;\n  border-radius: 50%;\n  background: #aaa;\n  color: #fff;\n  font-size: 9px;\n  font-weight: 700;\n  cursor: help;\n  vertical-align: middle;\n}\n\n.sf-help:hover { background: #777; }\n\n/* 읽기전용 */\n.input-readonly {\n  background: #f8f8f8 !important;\n  color: #666;\n  cursor: default;\n}\n\n/* 메모 textarea */\n.sf-row-memo {\n  align-items: flex-start;\n}\n\n.sf-row-memo > label {\n  margin-top: 6px;\n}\n\n/* 저장/삭제/취소 버튼 */\n.sf-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n  padding-left: 82px;\n}\n\n.required { color: #e74c3c; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
